const select = async function() {
    if ( !document.querySelector(".wpcf7-select") ) return;

    try {
        const CustomSelect = await (await import('../utils/custom-select')).default;
        document.querySelectorAll(".wpcf7-select").forEach(select => {
            if (select.options.length > 0) {
                select.options[0].disabled = true;
            }
            const customSelect = new CustomSelect(select, {
                // label: "Please select",
                value: "none",
                afterElement: '<svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                    '<path d="M1 1L9 9L17 1" stroke="#E84133"/>\n' +
                    '</svg>\n',
            })
        })
    } catch (e) {}
}

export const init = select;